import { WardType } from "./ward";

// eslint-disable-next-line import/prefer-default-export
export const IpdStatus = {
  ADMITTED: "admitted",
  DISCHARGED: "discharged"
} as const;

export const IpdCases = WardType;
